const mapProvince = province => ({
  id: province.id,
  name: province.name,
  code: province.code,
})

const mapRegion = region => ({
  id: region.id,
  name: region.name,
  code: region.code,
  phone_prefix: region.phone_prefix,
  provinces: region.provinces?.map(mapProvince),
})

const mapAddress = address => ({
  id: address.id,
  first_name: address.first_name,
  last_name: address.last_name,
  line_1: address.line_1,
  line_2: address.line_2,
  postcode: address.postcode,
  locality: address.locality,
  country: address.country,
  province: address.province,
  phone: address.phone,
  house_number: address.house_number,
  company: address.company,
})

const mapLocation = location => ({
  id: location.id,
  type: location.type,
  public_name: location.public_name,
  address: location.address ? mapAddress(location.address) : location.address,
  internal_id: location.internal_id,
  internal_name: location.internal_name,
  delivery_method_ids: location.delivery_method_ids,
  shipping_method_ids: location.shipping_method_ids,
  inventory_location_id: location.inventory_location_id,
  default_packaging_id: location.default_packaging_id,
})

const mapCarrierService = carrierService => ({
  id: carrierService.id,
  name: carrierService.name,
  service_name: carrierService.service_name,
  service_provider: carrierService.service_provider,
  is_connected: carrierService.is_connected,
  logo_url: carrierService.logo_url,
  supports_time_ranges: carrierService.supports_time_ranges,
  supports_modification: carrierService.supports_modification,
  is_reveni_contract: carrierService.is_reveni_contract,
  is_pickup_point: carrierService.is_pickup_point,
})

const mapCarrier = carrier => ({
  id: carrier.id,
  name: carrier.name,
  logo_url: carrier.logo_url,
})

const mapTimeRange = timeRange => ({
  id: timeRange.id,
  start: timeRange.start,
  end: timeRange.end,
})

const mapDeliveryMethod = method => ({
  id: method.id,
  internal_id: method.internal_id,
  internal_name: method.internal_name,
  type: method.type,
  name: method.name,
  visibility: method.visibility,
  is_enabled: method.is_enabled,
  enabled_for_exchanges: method.enabled_for_exchanges,
  enabled_for_refunds: method.enabled_for_refunds,
  enabled_for_mixed: method.enabled_for_mixed,
  regions: method.regions?.map(mapRegion),
  availability_criterion_ids: method.availability_criterion_ids,
  extra_fee: method.extra_fee,
  base_extra_fee: method.base_extra_fee,
  extra_fee_type: method.extra_fee_type,
  extra_fee_additional_transaction: method.extra_fee_additional_transaction,
  extra_fee_included_items: method.extra_fee_included_items,
  extra_fee_included_items_additional_transaction: method.extra_fee_included_items_additional_transaction,
  base_extra_fee_additional_transaction: method.base_extra_fee_additional_transaction,
  currency: method.currency,
  carbon_offset_fee: method.carbon_offset_fee,
  allows_multiple_return_labels: method.allows_multiple_return_labels,
  carrier_service: method.carrier_service ? mapCarrierService(method.carrier_service) : method.carrier_service,
  carrier: method.carrier ? mapCarrier(method.carrier) : method.carrier,
  location: method.location ? mapLocation(method.location) : method.location,
  locations: method.locations?.map(mapLocation),
  location_list_type: method.location_list_type,
  url: method.url,
  time_ranges: method.time_ranges?.map(mapTimeRange),
  supports_pickup_dates: method.supports_pickup_dates,
  delivery_address: method.delivery_address ? mapAddress(method.delivery_address) : method.delivery_address,
  delivery_location_name: method.delivery_location_name,
  return_instruction_set_id: method.return_instruction_set_id,
  return_instructions: method.return_instructions,
  configuration: method.configuration,
})

export const transformResponseLogisticsPreferences = response => ({
  delivery_methods: response.delivery_methods?.map(mapDeliveryMethod),
})
